
import { Inject } from 'vue-property-decorator'
import { Options, Vue } from 'vue-class-component'
import 'mapbox-gl/dist/mapbox-gl.css'
import mapboxgl from 'mapbox-gl'
import Loading from 'vue-loading-overlay'
import { Modal } from 'bootstrap'
import { $t } from '@geocms/localization'
import { MapFunctions } from '@campsabout/mapbox'
let campsaboutObject:any = null

interface IconTypesLabels {
  [key: string]: string;
}

@Options({
  computed: {
    $t () {
      return $t
    }
  },
  components: {
    Loading
  }
})
export default class MapComponent extends Vue {
  @Inject() http: any
  @Inject() Definitions: any
  @Inject() router: any

  private classColors = {
    obala: '#f3f2e7',
    zemlja: '#dedfc4',
    cesta: '#e2e6e8',
    vegetacija: '#98b87c',
    parking_podloga: '#e2e6e8',
    'objekt wc roof1': '#f28586',
    'objekt wc roof2': '#f28586',
    'objekt podloga': '#f28586',
    bazen_podloga: '#e4e9e8',
    bazen: '#8decfe',
    billboard: '#ffffff',

    // new classes
    periphery: '#A7DD88',
    campground: '#f3f2e7',
    road: '#e2e6e8',
    parking: '#e0e0e0',
    pool: '#8decfe',
    patio: '#dedfc4',
    line: '#ffffff', // for removal
    line_white: '#ffffff',
    line_black: '#000000',
    grass: '#B4D894',
    vegetation: '#709F50',
    unit_base_gray: '#e2e6e8',
    unit_base_green: '#95D07B',
    fence: '#000000',
    hedge: '#e2e6e8', // for removal
    treetop_light: '#8FBE72',
    treetop_dark: '#709F50',
    coastline: 'transparent',
    object_roof_light: '#f28586',
    object_roof_dark: '#CF7273',
    object_roof_light_gray: '#e0e0e0',
    object_roof_dark_gray: '#bbbbbb',
    object_base: '#F2F2F2',
    playground: '#68b29e',
    tennis: '#d2836f',
    barrier: '#ffffff',
    barrier_red: '#D20808',

    // Jadranka
    zone_Cikat: '#E6C29F',
    zone_Slatina: '#D24E3D',
    zone_Bijar1: '#D24E3D',
    zone_Bijar2: '#4CB8BE',

    // Atea
    gaia_green_villas: '#bbbbbb',

    // Oliva
    mhPremium: '#a6846b',
    mhComfort: '#da4456',
    mhStandard: '#d6915b',
    pitchZone1: '#371758',
    pitchZone2: '#427d9c',
    pitchZone3: '#989543'
  }
  private campGeojson = MapFunctions.getEmptyGeojson()
  private labelsGeojson = MapFunctions.getEmptyGeojson()
  private clickableIds: any = { openModal: {}, openPopup: {} }
  private numberArr: any = {}
  longitude = 0
  latitude = 0
  trigger!: boolean
  indexMode = false
  map!: any
  entities: any
  relData = []
  currentPopup: mapboxgl.Popup | null = null
  renderComponent = true
  currentPopupIndex = -1
  imageLayerVisible = true
  dashArraySequence = [
    [0, 4, 3],
    [0.5, 4, 2.5],
    [1, 4, 2],
    [1.5, 4, 1.5],
    [2, 4, 1],
    [2.5, 4, 0.5],
    [3, 4, 0],
    [0, 0.5, 3, 3.5],
    [0, 1, 3, 3],
    [0, 1.5, 3, 2.5],
    [0, 2, 3, 2],
    [0, 2.5, 3, 1.5],
    [0, 3, 3, 1],
    [0, 3.5, 3, 0.5]
  ]
  showImage = false
  step = 0
  showLegend = true
  checkedIconTypes: string[] = ['ico-sro', 'ico-ssro', 'struja-idle']
  // TODO
  selectedClusterIconType = 'ico-sro'
  iconTypes: string[] = ['ico-lamp', 'ico-sro', 'ico-ssro', 'struja-idle']
  iconTypesLabels: IconTypesLabels = {
    'ico-lamp': 'LAMP',
    'ico-sro': 'SRO',
    'ico-ssro': 'SSRO',
    'struja-idle': 'NCV'
  }

  isSatelliteView = true

  entityCode = ''
  error = false
  strujaFeatureIds: string[] = []

  getIconPath (iconType: string) {
    return require('../assets/map_files/' + iconType + '.svg')
  }

  getImagePath (iconType: string) {
    return require('../assets/map_files/' + iconType + '.png')
  }

  private async callApi(url: string): Promise<any | null> {
    if (!url) return null;
    try {
      const response = await fetch(url);
      if (!response.ok) {
        console.error(`Error: Received status code ${response.status} from ${url}`);
        return null;
      }
      const data = await response.json();
      return data;
    } catch (error) {
      console.error(`Error fetching data from ${url}:`, error);
      return null;
    }
  }


  async initializeCampsaboutObject() {
    await fetch(`https://campsabout.com/mapAPI/typeSJColors.php?id=1&group=zaton`).then(async (response) => {
      if (!response.ok) return
      const data = await response.json()
      let result: { [index: string]: string } = {}
      Object.keys(data).forEach((element: string) => {
        result[element] = data[element][0].color
      })
      this.classColors = (Object.assign(this.classColors, result))
    })
    await this.callApi('https://campsabout.com/camp/zaton/1/assets/gj/Zaton.json').then((data) => (this.campGeojson = data))
    await this.callApi('https://campsabout.com/mapAPI/natpisi.php?id=1&group=zaton').then((data) => (this.labelsGeojson = data))
    await this.callApi('https://campsabout.com/mapAPI/revision/getFeatures.php?propertyId=1&group=zaton&mapaids=*').then((data) => {
      const filteredData = data.filter((item: any) => item.noClick != 1)
      this.numberArr = {}
      data.forEach((feature: any) => {
        if (!feature.noClick) {
          if (feature.openModal) {
            this.clickableIds.openModal[feature.mapId] = true
          } else {
            this.clickableIds.openPopup[feature.mapId] = true
          }
        }
      })
      console.log(this.clickableIds)
      data.forEach((feature: any) => {
        if (feature.number) {
          this.numberArr[feature.mapId] = feature.number
        }
      })
    })
    campsaboutObject = {
      map: this.map,
      campGeojson: this.campGeojson,
      colors: MapFunctions.matchColorsWithIDs(this.campGeojson, this.classColors),
      sortedCampGeojson: MapFunctions.sortLayers(this.campGeojson),
      labelsGeojson: this.labelsGeojson,
      is3d: false,
      units3D: null,
      billboard3D: null,
      advertisement: null,
      geolocate: null,
      directions: null,
      poly: null,
      language: 'hr',
      onRouteChangeDel: null,
      clickableIds: this.clickableIds,
      numberArr: this.numberArr
    }
    await MapFunctions.initMap(campsaboutObject)
    //campsaboutObject.bbox = MapFunctions.createBoundBox(campsaboutObject, ['0'])
  }


  created () {
    if (localStorage.getItem('firmName') === 'trim') {
      this.checkedIconTypes = ['ico-switch', 'ap-idle', 'ico-manhole']
      this.selectedClusterIconType = 'ap-idle'
      this.iconTypes = ['ico-manhole', 'ico-switch', 'ap-idle']
      this.iconTypesLabels = {
        'ico-manhole': 'ŠAHT',
        'ico-switch': 'SWITCH',
        'ap-idle': 'ACC'
      }
      this.showImage = true
    }else
    if (localStorage.getItem('firmName') === 'zaton') {
      this.checkedIconTypes = ['ico-switch', 'ap-idle']
      this.selectedClusterIconType = 'ap-idle'
      this.iconTypes = ['ico-switch', 'ap-idle']
      this.iconTypesLabels = {
        'ico-switch': 'SWITCH',
        'ap-idle': 'ACC'
      }
    } else if (localStorage.getItem('firmName') === 'aminess') {
      this.checkedIconTypes = ['ico-sro', 'ico-ssro', 'struja-idle', 'ico-switch', 'ap-idle']
      this.selectedClusterIconType = 'ap-idle'
      this.iconTypes = ['ico-lamp', 'ico-sro', 'ico-ssro', 'struja-idle', 'ico-switch', 'ap-idle']
      this.iconTypesLabels = {
        'ico-switch': 'SWITCH',
        'ap-idle': 'ACC',
        'ico-lamp': 'LAMP',
        'ico-sro': 'SRO',
        'ico-ssro': 'SSRO',
        'struja-idle': 'NCV'
      }
    }
  }

  toggleLegend () {
    this.showLegend = !this.showLegend
    localStorage.setItem('showLegend', JSON.stringify(this.showLegend))
  }

  clusterIconChanged () {
    localStorage.setItem('selectedClusterIconType_'+localStorage.getItem('firmName'), JSON.stringify(this.selectedClusterIconType))
    const answer = {
      type: 'FeatureCollection',
      features: this.entities.features.filter((entity: {
        properties: { iconType: string }
      }) => entity.properties.iconType === this.selectedClusterIconType)
    }
    this.map.getSource('entity-clusters').setData(answer)
  }

  mounted () {
    // Retrieving the values from local storage
    const storedCheckedIconTypes = localStorage.getItem('checkedIconTypes_'+localStorage.getItem('firmName'))
    const storedSelectedClusterIconType = localStorage.getItem('selectedClusterIconType_'+localStorage.getItem('firmName'))
    const showLegend = localStorage.getItem('showLegend')

    // Parsing the retrieved values
    this.checkedIconTypes = storedCheckedIconTypes ? JSON.parse(storedCheckedIconTypes) : this.checkedIconTypes
    this.selectedClusterIconType = storedSelectedClusterIconType ? JSON.parse(storedSelectedClusterIconType) : this.selectedClusterIconType
    this.showLegend = showLegend ? JSON.parse(showLegend) : true
    this.initializeMapAndLoadStyle().then(() => {
      // The map style has finished loading, now call the test function
      this.test()
      this.$store.commit('setMapResizeDelegate', this.storeTest.bind(this))
    })
  }

  storeTest (): void {
    this.$nextTick(() => {
      this.map.resize()
    })
  }

  initializeMapAndLoadStyle () {
    return new Promise<void>((resolve, reject) => {
      mapboxgl.accessToken = 'pk.eyJ1Ijoiam9zbyIsImEiOiJjbDBpN3NnbWMwMDJlM2ptcng2bGIxazJjIn0.xuMyew046jayaAFfWnsfJQ'
      this.map = new mapboxgl.Map({
        container: 'map',
        style: 'mapbox://styles/joso/cltzjanet00mw01qub77penk0/draft'
      })

      this.map.on('load', () => {
        // The map has finished loading, resolve the promise
        resolve()

        // Add style switch button
        const styleSwitchButton = document.createElement('button')
        styleSwitchButton.textContent = 'Switch to Default View'
        styleSwitchButton.style.position = 'absolute'
        styleSwitchButton.classList.add('btn', 'btn-secondary', 'btn-sm')
        styleSwitchButton.style.top = '10px'
        styleSwitchButton.style.right = '10px'
        styleSwitchButton.onclick = () => {
          if (this.isSatelliteView) {
            this.map.setStyle('mapbox://styles/joso/clyprewpl00a901r18zm5gczr')
            styleSwitchButton.textContent = 'Switch to Satellite View'
            this.isSatelliteView = false
          } else {
            this.map.setStyle('mapbox://styles/joso/cltzjanet00mw01qub77penk0')
            styleSwitchButton.textContent = 'Switch to Default View'
            this.isSatelliteView = true
          }
        }
        this.map.getContainer().appendChild(styleSwitchButton)
        if(localStorage.getItem('firmName') === 'trim'){
          const imageSwitchButton = document.createElement('button')
          imageSwitchButton.textContent = 'Hide Image Layer'
          imageSwitchButton.style.position = 'absolute'
          imageSwitchButton.classList.add('btn', 'btn-secondary', 'btn-sm')
          imageSwitchButton.style.top = '50px'
          imageSwitchButton.style.right = '10px'
          imageSwitchButton.onclick = () => {
            if (this.map) {
              if (this.imageLayerVisible) {
                this.map.setLayoutProperty('my-layer', 'visibility', 'none')
                this.map.setLayoutProperty('tileset-layer', 'visibility', 'none')
                imageSwitchButton.textContent = 'Show Image Layer'
                this.imageLayerVisible = false
              } else {
                this.map.setLayoutProperty('my-layer', 'visibility', 'visible')
                this.map.setLayoutProperty('tileset-layer', 'visibility', 'visible')
                imageSwitchButton.textContent = 'Hide Image Layer'
                this.imageLayerVisible = true
              }
            }
          }
          this.map.getContainer().appendChild(imageSwitchButton)
        }

        if(localStorage.getItem('firmName') === 'zaton'){
          const imageSwitchButton = document.createElement('button')
          imageSwitchButton.textContent = 'Hide Zaton Map'
          imageSwitchButton.style.position = 'absolute'
          imageSwitchButton.classList.add('btn', 'btn-secondary', 'btn-sm')
          imageSwitchButton.style.top = '50px'
          imageSwitchButton.style.right = '10px'
          imageSwitchButton.onclick = () => {
            if (this.map) {
              if (this.imageLayerVisible) {
                this.map.setPaintProperty('camp-fill-layer', 'fill-opacity', 0)
                imageSwitchButton.textContent = 'Show Zaton Map'
                this.imageLayerVisible = false
              } else {
                this.map.setPaintProperty('camp-fill-layer', 'fill-opacity', 0.5)
                imageSwitchButton.textContent = 'Hide Zaton Map'
                this.imageLayerVisible = true
              }
            }
          }
          this.map.getContainer().appendChild(imageSwitchButton)
        }

      })

      this.map.on('style.load', () => {
        this.renderComponent = true //TODO need to fix this
        this.test()
      })

      this.map.on('error', (event: { error: any }) => {
        // If an error occurs during the map loading process, reject the promise
        reject(event.error)
      })
    })
  }

  async zoomToEntity (): Promise<void> {
    // Your method to fetch the entity data should go here, this is just a placeholder
    const featureWithCode = this.entities.features.find((feature: any) => {
      // Replace 'codeProperty' with the actual property name that contains the code in your feature object
      const code = feature.properties.code
      return code === this.entityCode
    })
    if (featureWithCode) {
      // Then you could zoom to the entity location like this
      this.map.flyTo({
        center: [featureWithCode.geometry.coordinates[0], featureWithCode.geometry.coordinates[1]],
        zoom: 18 // Set the zoom level to your preference
      })

      const allIds = [featureWithCode.properties.id]

      this.map.setLayoutProperty('icon-points', 'icon-size', this.getIconSizes(allIds))
      this.map.setPaintProperty('icon-points', 'icon-opacity', this.getIconOpacities(allIds))

      this.map.addSource('single-point', {
        type: 'geojson',
        data: {
          type: 'FeatureCollection',
          features: []
        }
      })
      this.map.getSource('single-point').setData(featureWithCode)

      // Initialize an index for cycling through the colors
      let colorIndex = 0

      // Define your colors
      const colors = ['blue', 'lightblue']

      // Set initial color and add the layer
      this.map.addLayer({
        id: 'circle-overlay',
        type: 'circle',
        source: 'single-point',
        paint: {
          'circle-radius': 30,
          'circle-color': colors[colorIndex],
          'circle-opacity': 0.5
        }
      })

      // Create a function to update the color
      const updateColor = () => {
        // Update the color
        this.map.setPaintProperty('circle-overlay', 'circle-color', colors[colorIndex])

        // Update the index for the next color
        colorIndex = (colorIndex + 1) % colors.length
      }

      // Call the function every 500 milliseconds (0.5 seconds)
      const intervalId = setInterval(updateColor, 500)

      // Clear the interval after 10 seconds
      setTimeout(() => {
        clearInterval(intervalId)

        // Remove the circle layer
        this.map.removeLayer('circle-overlay')
        this.map.removeSource('single-point')
      }, 30000)

      this.error = false
    } else {
      this.error = true
    }
  }

  updateSymbolVisibility (): void {
    localStorage.setItem('checkedIconTypes_'+localStorage.getItem('firmName'), JSON.stringify(this.checkedIconTypes))
    this.map.setFilter('icon-points', ['in', 'iconType', ...this.checkedIconTypes])
  }

  async test (): Promise<void> {
    const response = await this.http.get(process.env.VUE_APP_BASE_URL + 'map')
    this.entities = response.data.data
    this.generateMap()
  }

  async updateMapData (id: string) {
    if (this.checkedIconTypes.includes('ico-lamp')) {
      const response = await this.http.get(process.env.VUE_APP_BASE_URL + 'maprelation/' + id)
      this.relData = response.data
      // Update the arrows with the relationship data
      await this.connectUnclusteredPoints(this.relData)
      this.animateDashArray(0)
    }
  }

  testingRadius (point: mapboxgl.MapboxGeoJSONFeature) {
    const features = this.map.querySourceFeatures('entities', {
      filter: ['has', 'point_count']
    })

    // find the closest feature to the point
    let closestFeature: any
    let minDistance = Infinity
    // eslint-disable-next-line camelcase
    for (const feature of features) {
      const pointCoordinates = point.geometry.type === 'Point' ? point.geometry.coordinates : undefined
      const center = feature.geometry.coordinates
      if (pointCoordinates) {
        const distance = new mapboxgl.LngLat(center[0], center[1]).distanceTo(new mapboxgl.LngLat(pointCoordinates[0], pointCoordinates[1]))
        if (distance < minDistance) {
          minDistance = distance
          closestFeature = feature
        }
      }
    }

    // calculate the cluster radius based on the size of the closest feature
    return minDistance / Math.sqrt(closestFeature.properties.point_count)
  }

  isPointInCluster (point: mapboxgl.MapboxGeoJSONFeature): boolean {
    const clusters = this.map.querySourceFeatures('entities', {
      filter: ['has', 'point_count']
    })

    for (const cluster of clusters) {
      const center = cluster.geometry.coordinates
      const pointCoordinates = point.geometry.type === 'Point' ? point.geometry.coordinates : undefined
      if (pointCoordinates) {
        const distance = new mapboxgl.LngLat(center[0], center[1]).distanceTo(new mapboxgl.LngLat(pointCoordinates[0], pointCoordinates[1]))
        if (distance > this.testingRadius(point)) {
          return true
        }
      }
    }

    return false
  }

  animateDashArray (timestamp: number) {
    const speed = 50
    const newStep = Math.floor((timestamp / speed) % this.dashArraySequence.length)

    if (newStep !== this.step) {
      this.map.setPaintProperty('arrow-layer-dashed', 'line-dasharray', this.dashArraySequence[this.step])
      this.step = newStep
    }

    requestAnimationFrame(this.animateDashArray.bind(this))
  }

  addArrowLayer (linesGeoJSON: any) {
    // Remove existing 'arrows' source and layers if they exist
    if (this.map.getSource('arrows')) {
      this.map.removeLayer('arrow-layer-background')
      this.map.removeLayer('arrow-layer-dashed')
      this.map.removeSource('arrows')
    }
    this.map.addSource('arrows', {
      type: 'geojson',
      data: {
        type: 'FeatureCollection',
        features: linesGeoJSON
      }
    })
    // Add a line layer without line-dasharray defined to fill the gaps in the dashed line
    this.map.addLayer({
      id: 'arrow-layer-background',
      type: 'line',
      source: 'arrows',
      layout: {
        'line-join': 'round',
        'line-cap': 'round'
      },
      paint: {
        'line-color': '#ffff00',
        'line-width': 3,
        'line-opacity': 0.4
      }
    }, 'icon-points')

    // Add a line layer with line-dasharray set to the first value in dashArraySequence
    this.map.addLayer({
      id: 'arrow-layer-dashed',
      type: 'line',
      source: 'arrows',
      layout: {
        'line-join': 'round',
        'line-cap': 'round'
      },
      paint: {
        'line-color': '#ffff00',
        'line-width': 3,
        'line-dasharray': [0, 4, 3]
      }
    }, 'icon-points')
  }

  async connectUnclusteredPoints (relationshipData: any[]): Promise<void> {
    // Obtain unclustered points from the 'icon-points' layer
    const unclusteredPoints = this.entities.features

    // Create a new array to store the LineString GeoJSON objects that should be added to the map
    const linesGeoJSON: any[] = []
    const allIds: any[] = []

    // Iterate over the relationship data and check if any of the points are within a cluster
    for (const [end, start] of Object.entries(relationshipData)) {
      if (start === null) continue

      const startFeature = unclusteredPoints.find((point: { properties: { id: any } }) => point.properties.id === start)
      const endFeature = unclusteredPoints.find((point: { properties: { id: any } }) => point.properties.id === end)

      // Check if any of the points are within a cluster
      if (this.isPointInCluster(startFeature) || this.isPointInCluster(endFeature)) {
        // If either point is in a cluster, do not create the LineString and continue to the next relationship
        continue
      }

      if (endFeature === undefined) {
        continue
      }
      /* this.map.setFeatureState({ source: 'entities', id: endFeature.id }, { change_opacity: true })
      console.log(this.map.getFeatureState({ source: 'entities', id: endFeature.id })) */
      allIds.push(endFeature.properties.id)

      const startCoordinates = startFeature.geometry.coordinates
      const endCoordinates = endFeature.geometry.coordinates

      // Create the LineString GeoJSON object and add it to the array
      const lineGeoJSON = {
        type: 'Feature',
        geometry: {
          type: 'LineString',
          coordinates: [startCoordinates, endCoordinates]
        }
      }

      linesGeoJSON.push(lineGeoJSON)
    }

    this.addArrowLayer(linesGeoJSON)
    this.map.setLayoutProperty('icon-points', 'icon-size', this.getIconSizes(allIds))
    this.map.setPaintProperty('icon-points', 'icon-opacity', this.getIconOpacities(allIds))
  }

  generateMap (mapUpdated = false, cluster = true) {
    if (!mapUpdated) {
      const filteredEntities = this.entities.features.filter((entity: {
        properties: { iconType: string }
      }) => entity.properties.iconType === this.selectedClusterIconType)
      const answer = {
        type: 'FeatureCollection',
        features: filteredEntities
      }
      if(this.showImage){
        this.map.addSource('my-source', {
          "type": "image",
          "url": this.getImagePath('koversada'),
          "coordinates": [
            [13.610872533, 45.136310612],
            [13.617992154, 45.136625937],
            [13.618265563, 45.130452494],
            [13.611145971, 45.130137161]
          ]
        });
        this.map.addLayer({
          id: 'my-layer',
          'type': 'raster',
          'source': 'my-source',
          'paint': {
            'raster-fade-duration': 0,
            'raster-opacity': 0.5
          }
        });

        // Add the hosted Mapbox tileset as a source
        this.map.addSource('mapbox-tileset', {
          "type": "image",
          "url": this.getImagePath('koversadaBig'),
          "coordinates": [
            [13.59431264, 45.14664839], // Top-left
            [13.62086774, 45.14728560], // Top-right
            [13.62173370, 45.12959157], // Bottom-right
            [13.5951652, 45.1289459] // Bottom-left
          ]
        })

        this.map.addLayer({
          id: 'tileset-layer',
          'type': 'raster',
          'source': 'mapbox-tileset',
          'paint': {
            'raster-fade-duration': 0,
            'raster-opacity': 0.5
          }
        });
      }
      this.initializeCampsaboutObject()
      this.map.addSource('entity-clusters', {
        type: 'geojson',
        data: answer,
        cluster: cluster,
        clusterMaxZoom: 12, // Max zoom to cluster points on
        clusterRadius: 50 // Radius of each cluster when clustering points (defaults to 50)
      })
      this.map.addSource('entities', {
        type: 'geojson',
        data: this.entities,
        cluster: cluster,
        clusterMaxZoom: 12, // Max zoom to cluster points on
        clusterRadius: 50 // Radius of each cluster when clustering points (defaults to 50)
      })
      this.map.addLayer({
        id: 'clusters',
        source: 'entity-clusters',
        type: 'circle',
        filter: ['has', 'point_count'],
        paint: {
          'circle-color': [
            'step',
            ['get', 'point_count'],
            '#51bbd6',
            100,
            '#f1f075',
            750,
            '#f28cb1'
          ],
          'circle-radius': [
            'step',
            ['get', 'point_count'],
            20,
            100,
            30,
            750,
            40
          ]
        }
      })
      this.map.addLayer({
        id: 'cluster-count',
        type: 'symbol',
        source: 'entity-clusters',
        filter: ['has', 'point_count'],
        layout: {
          'text-field': '{point_count_abbreviated}',
          'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
          'text-size': 12
        }
      })
      this.map.addLayer({
        id: 'icon-points',
        type: 'symbol',
        source: 'entities', // Change this line
        filter: ['all', ['!', ['has', 'point_count']], ['has', 'iconType']],
        layout: {
          'icon-image': ['get', 'iconType'],
          'icon-allow-overlap': true,
          'icon-size': [
            'case',
            ['==', ['get', 'iconType'], 'ico-sro'],
            0.6,
            ['==', ['get', 'iconType'], 'struja-idle'],
            0.6,
            ['==', ['get', 'iconType'], 'ico-switch'],
            0.6,
            ['==', ['get', 'iconType'], 'ico-manhole'],
            0.6,
            ['==', ['get', 'iconType'], 'ap-idle'],
            0.6,
            0.3
          ],
          'symbol-sort-key': [
            'case',
            ['==', ['get', 'iconType'], 'ico-sro'],
            8,
            ['==', ['get', 'iconType'], 'struja-idle'],
            9,
            ['==', ['get', 'iconType'], 'ico-switch'],
            9,
            ['==', ['get', 'iconType'], 'ico-manhole'],
            9,
            ['==', ['get', 'iconType'], 'ap-idle'],
            9,
            0
          ]
        },
        paint: {
          'icon-opacity': [
            'case',
            ['boolean', ['feature-state', 'change_opacity'], false],
            1,
            ['all', ['!=', ['get', 'iconType'], 'ico-sro'], ['!=', ['get', 'iconType'], 'ico-switch'], ['!=', ['get', 'iconType'], 'ico-manhole'], ['!=', ['get', 'iconType'], 'ap-idle'], ['!=', ['get', 'iconType'], 'struja-idle']],
            0.1,
            1
          ]
        }
      })

      this.map.addLayer({
        id: 'unclustered-point',
        type: 'circle',
        source: 'entities', // Change this line
        filter: ['all', ['!', ['has', 'point_count']], ['!', ['has', 'iconType']]],
        paint: {
          'circle-color': '#11b4da',
          'circle-radius': 6,
          'circle-stroke-width': 2,
          'circle-stroke-color': '#fff'
        }
      })

      this.map.on('click', 'clusters', (e: any) => {
        const features = this.map.queryRenderedFeatures(e.point, {
          layers: ['clusters']
        })
        const clusterId = features[0].properties.cluster_id
        this.map.getSource('entity-clusters').getClusterExpansionZoom(
          clusterId,
          (err: any, zoom: any) => {
            if (err) return
            this.map.easeTo({
              center: features[0].geometry.coordinates,
              zoom: zoom
            })
          }
        )
      })
      this.map.on('click', 'icon-points', async (e: any) => {
        this.currentPopupIndex = -1
        const clickedPoint = e.point
        const clickedFeatures = this.map.queryRenderedFeatures(clickedPoint, { layers: ['icon-points'] })
        // Check if there are any clicked features
        if (clickedFeatures && clickedFeatures.length > 0) {
          // Sort the clicked features based on their rendering order (symbol-sort-key)
          const topmostFeature = this.getTopmostFeature(clickedFeatures, clickedPoint)
          const feature = {
            geometry: {
              coordinates: topmostFeature.geometry.coordinates
            },
            properties: topmostFeature.properties
          }
          await this.handleIconPointsClick({ features: [feature] })
        }
        // await this.handleIconPointsClick(e)
      })

      this.map.on('click', 'unclustered-point', async (e: any) => {
        if (this.currentPopup) {
          this.currentPopup.remove()
        }
        const coordinates = e.features[0].geometry.coordinates.slice()
        const id = e.features[0].properties.id
        const code = e.features[0].properties.code

        // Update the map with new data
        await this.updateMapData(id)

        // Rest of the code
        const entitiesWithSameCoordinates = this.entities.features.filter((entity: {
          geometry: { coordinates: any[] }
        }) => {
          return entity.geometry.coordinates[0] === coordinates[0] && entity.geometry
            .coordinates[1] === coordinates[1]
        })
        const popup = new mapboxgl.Popup({ closeOnClick: false })
          .setLngLat(coordinates)
          .setHTML(`<p>${$t.code}: ${code}</p><br><button class="btn btn-secondary btn-sm open-popup" >${$t.open}</button><br><p>${$t.entitiesWithSameCoordinates}":" ${entitiesWithSameCoordinates.length}</p>`)
        popup.addTo(this.map)
        this.currentPopup = popup
        const btn = document.getElementsByClassName('open-popup')[0]
        btn.addEventListener('click', () => {
          this.router.push({
            name: this.Definitions.Entity.Edit,
            params: { id: id }
          })
        })
      })
      /* this.map.on('move', () => {
        this.animateDashArray(0)
      }) */
      this.map.on('zoomend', () => {
        this.handleZoomChange()
        this.map.moveLayer('icon-points');
      })
    }
    if (this.entities.features.length > 0) {
      if (!mapUpdated) {
        this.changeZoomOnSelectClusterIcon()
      }

      // this.animateDashArray(0)
      this.renderComponent = false
      if (this.strujaFeatureIds.length === 0) {
        this.strujaFeatureIds = this.entities.features
          .filter((feature: { properties: { iconType: string } }) => feature.properties.iconType === 'struja-idle')
          .map((feature: { properties: { code: string } }) => feature.properties.code)
      }
      this.updateSymbolVisibility()
    }
  }

  changeZoomOnSelectClusterIcon ()
  {
    const bounds = new mapboxgl.LngLatBounds()
    const buffer = 0.0001
    for (const element of this.entities.features) {
      if (element.properties.iconType === this.selectedClusterIconType) {
        console.log(element)
        const coordinates = element.geometry.coordinates

        const lng = coordinates[0]
        const lat = coordinates[1]

        bounds.extend([
          [lng - buffer, lat - buffer],
          [lng + buffer, lat + buffer]
        ])
      }
    }

    this.map.fitBounds(bounds, {
      padding: 20,
      maxZoom: 5
    })
  }

  async handleZoomChange (): Promise<void> {
    const zoomLevel = this.map.getZoom()

    // Adjust the value 14 to the desired zoom level for clustered points to appear
    if (zoomLevel <= 16) {
      if(localStorage.getItem('firmName') === 'zaton'){
        await this.changeIconTypeByIdEcabinet()
      }else {
        await this.changeIconTypeById()
      }
      await this.connectUnclusteredPoints(this.relData)
    }
    /* const strujaIdleFeatures = this.map.querySourceFeatures('entities', {
      filter: ['in', 'iconType', 'struja-idle', 'ico-sro']
    })
    this.map.setLayoutProperty('icon-points', 'icon-size', this.calculateAdjustedSize(zoomLevel), strujaIdleFeatures) */
  }

  calculateAdjustedSize (zoomLevel: number): number {
    // Calculate the adjusted icon size based on the zoom level
    // You can adjust the formula based on your requirements
    const baseSize = 0.4 // Set to the original default size
    const maxSize = 0.6 // Set to the original maximum size
    const minZoom = 12
    const maxZoom = 16

    // Linear interpolation to adjust the size between baseSize and maxSize
    const adjustedSize = baseSize + (maxSize - baseSize) * (zoomLevel - minZoom) / (maxZoom - minZoom)

    // Return the adjusted size
    return Math.min(maxSize, Math.max(baseSize, adjustedSize))
  }

  async changeIconTypeById (): Promise<void> {
    const response = await this.http.get('https://tri-m.app/ormari/api/ormarOkCode.php')
    // Define new icon images according to the newIconType
    const newIconImage = [
      'match',
      ['get', 'code'],
      ...Object.entries(response.data).map(([key, value]) => ({
        key,
        value
      })).flatMap(code => [code.key, code.value]),
      ['get', 'iconType'] // default value
    ]

    this.map.setLayoutProperty('icon-points', 'icon-image', newIconImage)
  }

  async changeIconTypeByIdEcabinet (): Promise<void> {
    const response = await this.http.get('https://tri-m.app/ecabinet/status.php')
    // Define new icon images according to the newIconType
    const newIconImage = [
      'match',
      ['get', 'code'],
      ...Object.entries(response.data).map(([key, value]) => ({
        key,
        value
      })).flatMap(code => [code.key, code.value]),
      ['get', 'iconType'] // default value
    ]
    console.log(newIconImage)
    this.map.setLayoutProperty('icon-points', 'icon-image', newIconImage)
  }

  getIconOpacities (allIds: any[]) {
    return [
      'case',
      ['in', ['get', 'id'], ['literal', allIds]],
      1,
      [
        'all',
        ['!=', ['get', 'iconType'], 'ico-sro'],
        ['!=', ['get', 'iconType'], 'ap-idle'],
        ['!=', ['get', 'iconType'], 'ap-inactive'],
        ['!=', ['get', 'iconType'], 'ap-active'],
        ['!=', ['get', 'iconType'], 'ap-warning'],
        ['!=', ['get', 'iconType'], 'ico-switch'],
        ['!=', ['get', 'iconType'], 'ico-manhole'],
        ['!=', ['get', 'iconType'], 'struja-idle'],
        ['!=', ['get', 'iconType'], 'struja-on'],
        ['!=', ['get', 'iconType'], 'struja-off'],
        ['!=', ['get', 'iconType'], 'struja-warning']
      ],
      0.1,
      1
    ]
  }

  getIconSizes (allIds: any[]) {
    return [
      'interpolate',
      ['linear'],
      ['zoom'],
      16, [
        'case',
        ['==', ['get', 'iconType'], 'struja-idle'], 0.6,
        ['==', ['get', 'iconType'], 'struja-on'], 0.6,
        ['==', ['get', 'iconType'], 'struja-off'], 0.6,
        ['==', ['get', 'iconType'], 'struja-warning'], 0.6,
        ['in', ['get', 'id'], ['literal', allIds]], 0.2,
        ['==', ['get', 'iconType'], 'ico-sro'], 0.6,
        ['==', ['get', 'iconType'], 'ap-idle'], 0.6,
        ['==', ['get', 'iconType'], 'ap-inactive'], 0.6,
        ['==', ['get', 'iconType'], 'ap-active'], 0.6,
        ['==', ['get', 'iconType'], 'ap-warning'], 0.6,
        ['==', ['get', 'iconType'], 'ico-manhole'], 0.6,
        ['==', ['get', 'iconType'], 'ico-switch'], 0.6,
        0.3
      ],
      17, [
        'case',
        ['==', ['get', 'iconType'], 'struja-idle'], 0.6,
        ['==', ['get', 'iconType'], 'struja-on'], 0.6,
        ['==', ['get', 'iconType'], 'struja-off'], 0.6,
        ['==', ['get', 'iconType'], 'struja-warning'], 0.6,
        ['in', ['get', 'id'], ['literal', allIds]], 0.4,
        ['==', ['get', 'iconType'], 'ico-sro'], 0.6,
        ['==', ['get', 'iconType'], 'ap-idle'], 0.6,
        ['==', ['get', 'iconType'], 'ap-inactive'], 0.6,
        ['==', ['get', 'iconType'], 'ap-active'], 0.6,
        ['==', ['get', 'iconType'], 'ap-warning'], 0.6,
        ['==', ['get', 'iconType'], 'ico-manhole'], 0.6,
        ['==', ['get', 'iconType'], 'ico-switch'], 0.6,
        0.3
      ],
      18, [
        'case',
        ['==', ['get', 'iconType'], 'struja-idle'], 0.6,
        ['==', ['get', 'iconType'], 'struja-on'], 0.6,
        ['==', ['get', 'iconType'], 'struja-off'], 0.6,
        ['==', ['get', 'iconType'], 'struja-warning'], 0.6,
        ['in', ['get', 'id'], ['literal', allIds]], 0.6,
        ['==', ['get', 'iconType'], 'ico-sro'], 0.6,
        ['==', ['get', 'iconType'], 'ap-idle'], 0.6,
        ['==', ['get', 'iconType'], 'ap-inactive'], 0.6,
        ['==', ['get', 'iconType'], 'ap-active'], 0.6,
        ['==', ['get', 'iconType'], 'ap-warning'], 0.6,
        ['==', ['get', 'iconType'], 'ico-manhole'], 0.6,
        ['==', ['get', 'iconType'], 'ico-switch'], 0.6,
        0.3
      ]
    ]
  }

  getTopmostFeature (features: string | any[], clickedPoint: any) {
    let topmostFeature = null
    let topmostDistance = Infinity
    for (let i = 0; i < features.length; i++) {
      const clickedLatLng = this.map.unproject(clickedPoint)

      const clickedPointCoordinates = {
        latitude: clickedLatLng.lat,
        longitude: clickedLatLng.lng
      }
      const currentFeature = features[i]
      const currentDistance = this.getDistanceInMeters(
        {
          latitude: currentFeature.geometry.coordinates[1],
          longitude: currentFeature.geometry.coordinates[0]
        },
        clickedPointCoordinates)
      const currentIconName = currentFeature.properties.iconType

      if (currentDistance <= 500 && ['ico-sro', 'struja-idle', 'struja-on', 'struja-off', 'struja-warning'].includes(currentIconName)) {
        if (currentDistance < topmostDistance) {
          topmostFeature = currentFeature
          topmostDistance = currentDistance
        }
      }
    }
    if (topmostFeature !== null) {
      return topmostFeature
    } else {
      return features[0]
    }
  }

  getDistanceInMeters (point1: any, point2: any) {
    const earthRadius = 6371e3 // Radius of the Earth in meters
    const {
      latitude: lat1,
      longitude: lon1
    } = point1
    const {
      latitude: lat2,
      longitude: lon2
    } = point2

    const latDelta = this.degToRad(lat2 - lat1)
    const lonDelta = this.degToRad(lon2 - lon1)

    const a =
      Math.sin(latDelta / 2) * Math.sin(latDelta / 2) +
      Math.cos(this.degToRad(lat1)) * Math.cos(this.degToRad(lat2)) *
      Math.sin(lonDelta / 2) * Math.sin(lonDelta / 2)
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
    return earthRadius * c
  }

  degToRad (degrees: number) {
    return degrees * (Math.PI / 180)
  }

  async handleIconPointsClick (e: any) {
    if (this.currentPopup) {
      this.currentPopup.remove()
    }
    const coordinates = e.features[0].geometry.coordinates.slice()
    const id = e.features[0].properties.id
    const code = e.features[0].properties.code

    // Update the map with new data
    await this.updateMapData(id)
    const precision = 100000
    // Rest of the code
    const entitiesWithSameCoordinates = this.entities.features.filter((entity: {
      id: string,
      geometry: { coordinates: any[] },
      properties: { iconType: string, code: string }
    }) => {
      return entity.id === id ||
        (
          Math.round(parseFloat(entity.geometry.coordinates[0]) * precision) === Math.round(parseFloat(coordinates[0]) * precision) &&
          Math.round(parseFloat(entity.geometry.coordinates[1]) * precision) === Math.round(parseFloat(coordinates[1]) * precision)
        )
    }).map((entity: { properties: { iconType: string, code: string, id: string } }) => {
      return {
        code: entity.properties.code,
        iconType: entity.properties.iconType,
        id: entity.properties.id
      }
    })
    let additionalButtons = '<div class="list-group">'
    for (const entity of entitiesWithSameCoordinates) {
      if (entity.iconType.includes('struja')) {
        additionalButtons += `<button class="list-group-item list-group-item-action controller-ncv-button btn-outline-secondary btn-sm btn-fixed text-truncate w-100 small-font" title="View ormar ${entity.code}" data-entitycode="${entity.code}" style="width: 120px;">View ormar ${entity.code}</button>`
      } else if (entity.iconType.includes('ap-idle') || entity.iconType.includes('ap-inactive') || entity.iconType.includes('ap-active') || entity.iconType.includes('ap-warning')) {
        additionalButtons += `<button class="list-group-item list-group-item-action acc-button btn-outline-secondary btn-sm btn-fixed text-truncate w-100 small-font" title="View ACC ${entity.code}" data-entitycode="${entity.code}" style="width: 120px;">View ACC ${entity.code}</button>`
      }
      additionalButtons += `<button class="list-group-item list-group-item-action additional-button btn-outline-secondary btn-sm btn-fixed text-truncate w-100 small-font" title="Open ${entity.code}" data-entityid="${entity.id}" data-entitycode="${entity.code}" style="width: 120px;">Open ${entity.code}</button>`
    }
    additionalButtons += '</div>'
    this.currentPopupIndex = entitiesWithSameCoordinates.findIndex((entity: { code: any }) => entity.code === code)
    const popup = new mapboxgl.Popup({ closeOnClick: false })
      .setLngLat(coordinates)
      .setHTML(`<div class="d-flex flex-column h-100">
    <div class="input-group input-group-sm mb-2">
      <button id="navigationButton" class="btn btn-outline-secondary">
        <span class="bi bi-geo-fill"></span>
      </button>
      <input type="text" class="form-control" readonly value="${$t.code}: ${code}">
    </div>
    ${additionalButtons}
    <p class="small-font mt-3 mb-0">${$t.entitiesWithSameCoordinates}: ${entitiesWithSameCoordinates.length}</p>
    ${entitiesWithSameCoordinates.length > 1 ? '<button id="nextButton" class="btn btn-primary mt-3">Next</button>' : ''}
  </div>`)
    popup.addTo(this.map)
    this.currentPopup = popup
    this.currentPopupIndex++
    if (entitiesWithSameCoordinates.length > 1) {
      const nextButton = document.getElementById('nextButton')
      if (nextButton) {
        nextButton.addEventListener('click', () => {
          if (this.currentPopupIndex >= entitiesWithSameCoordinates.length) {
            this.currentPopupIndex = 0
          }
          const nextFeature = entitiesWithSameCoordinates[this.currentPopupIndex]
          const feature = {
            geometry: {
              coordinates: coordinates
            },
            properties: nextFeature
          }
          this.handleIconPointsClick({ features: [feature] })
        })
      }
    }

    const navigationButton = document.getElementById('navigationButton')
    if (navigationButton) {
      navigationButton.addEventListener('click', () => {
        const destination = `${coordinates[1]},${coordinates[0]}` // Reversed order of coordinates for Google Maps
        const googleMapsUrl = `https://www.google.com/maps/dir/?api=1&destination=${destination}`
        window.open(googleMapsUrl)
      })
    }

    const ncvBtns = document.getElementsByClassName('controller-ncv-button')
    Array.from(ncvBtns).forEach(btn => {
      btn.addEventListener('click', () => {
        const entityCode = btn.getAttribute('data-entitycode')
        const iframe = document.getElementById('yourIframeId') as HTMLIFrameElement
        const iframeOther = document.getElementById('accIframe') as HTMLIFrameElement;
        iframe.style.display = 'initial';
        iframeOther.style.display = 'none';
        if (iframe !== null) {
          if (iframe.contentWindow !== null) {
            iframe.contentWindow.postMessage({
              command: 'openModalOrmar',
              code: entityCode
            }, '*')
          }
        }
        const myModalElement = document.getElementById('myModal')
        if (myModalElement !== null) {
          const myModal = new Modal(myModalElement, {})
          myModal.show()
        }
      })
    })

    const accBtns = document.getElementsByClassName('acc-button');
    Array.from(accBtns).forEach(btn => {
      btn.addEventListener('click', () => {
        const entityCode = btn.getAttribute('data-entitycode');
        const iframe = document.getElementById('accIframe') as HTMLIFrameElement;
        const iframeOther = document.getElementById('yourIframeId') as HTMLIFrameElement;
        iframe.style.display = 'initial';
        iframeOther.style.display = 'none';
        if (iframe !== null) {
          // Construct the new URL with the entityCode
          const url = `https://tri-m.app/ecabinet/index.php?name=${entityCode}`;

          // Set the iframe src to the constructed URL
          iframe.src = url;
        }

        // Open the modal
        const myModalElement = document.getElementById('myModal');
        if (myModalElement !== null) {
          const myModal = new Modal(myModalElement, {});
          myModal.show();
        }
      })
    })

    const additionalBtns = document.getElementsByClassName('additional-button')
    Array.from(additionalBtns).forEach(btn => {
      btn.addEventListener('click', () => {
        const entityId = btn.getAttribute('data-entityid')
        // console.log(entityId)
        if (entityId) {
          this.router.push({
            name: this.Definitions.Entity.Edit,
            params: { id: entityId }
          })
        }
      })
    })
  }
}

